<template>
  <div class="video-link-field">
    <div class="video-link-field__row" @keydown.enter.prevent="check">
      <FormElement
        :value="value"
        :title="title"
        tagName="input"
        placeholder="Ссылка на ролик VK Видео или Rutube"
        :errorText="errors"
        class="video-link-field__input"
        @update:value="onInput"
      />
      <button
        type="button"
        class="video-link-field__check"
        :disabled="isLoading || !value.trim()"
        @click="check"
      >
        <AppLoader v-if="isLoading" />
        <span v-else>Проверить</span>
      </button>
    </div>
    <p class="video-link-field__hint">
      Вставьте ссылку на ролик VK Видео (vkvideo.ru, vk.com, клипы) или Rutube (видео и Shorts) — или код для
      встраивания с площадки. Ролик остаётся на площадке, в приложении и на сайте он играет в её плеере.
    </p>
    <div v-if="preview" class="video-link-field__preview">
      <NotifyComponent
        v-if="!preview.available"
        status="error"
        text="Площадка сообщила, что ролик удалён или закрыт — в приложении и на сайте он не показывается. Вставьте другую ссылку или удалите видео"
      />
      <div class="video-link-field__media" :class="{ vertical: preview.vertical }">
        <iframe
          v-if="isPlayerShown"
          :src="preview.embedUrl"
          :title="preview.title || 'Видео'"
          class="video-link-field__player"
          allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock"
          allowfullscreen
        />
        <button v-else type="button" class="video-link-field__cover" title="Смотреть" @click="isPlayerShown = true">
          <img v-if="preview.thumbnailUrl" :src="preview.thumbnailUrl" alt="" loading="lazy">
          <span class="video-link-field__play" />
        </button>
      </div>
      <div class="video-link-field__info">
        <span class="video-link-field__title">{{ preview.title || 'Ролик без названия' }}</span>
        <span class="video-link-field__meta">
          {{ providerName }}<template v-if="duration"> · {{ duration }}</template><template v-if="preview.vertical"> · вертикальный</template>
        </span>
        <a :href="preview.url" target="_blank" rel="noopener noreferrer" class="video-link-field__link">Открыть на площадке</a>
        <DeleteTextBtn @click="remove">
          Удалить видео
        </DeleteTextBtn>
      </div>
    </div>
  </div>
</template>

<script lang="ts" src="./VideoLinkField.ts"></script>

<style scoped lang="scss" src="./VideoLinkField.scss"></style>
